"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardEvents = void 0;
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
const assert_1 = require("../../../../utils/assert");
function useKeyboardEvents(props) {
    const { inputEl, listEl, focusedTermPosition, submit, setText } = props;
    /**
     * Fuction to handle onKeyDown event.
     */
    const handleKeyDown = event_callback_hook_1.useEventCallback((e) => {
        const focusedEl = document.activeElement;
        assert_1.assertNonNullish(focusedEl, 'Unexpected error, focused was lost.');
        assert_1.assertNonNullish(inputEl, 'No reference to input.');
        // focus first suggestion or submit filters
        if (focusedEl.tagName === 'INPUT') {
            if (e.key === 'ArrowDown') {
                assert_1.assertNonNullish(listEl, 'No reference to suggestion list.');
                const child = listEl.firstElementChild;
                assert_1.assertNonNullish(child, 'Invalid first child, null found.');
                if (child instanceof HTMLElement) {
                    child.focus();
                }
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                submit();
            }
        }
        if (focusedEl.tagName === 'LI') {
            // next suggestion
            if (e.key === 'ArrowDown') {
                const sibling = focusedEl.nextElementSibling;
                assert_1.assertNonNullish(sibling, 'Invalid next sibling, null found.');
                if (sibling instanceof HTMLElement) {
                    sibling.focus();
                }
            }
            // previous suggestion
            if (e.key === 'ArrowUp') {
                const sibling = focusedEl.previousElementSibling;
                if (sibling instanceof HTMLElement) {
                    sibling === null || sibling === void 0 ? void 0 : sibling.focus();
                }
                else {
                    setTimeout(() => {
                        assert_1.assertNonNullish(inputEl, 'No reference to input.');
                        inputEl.focus();
                    });
                }
            }
            // replace term with suggestion
            if (e.key === 'Enter' || e.key === 'Tab') {
                setText((text) => {
                    const textBefore = text.substring(0, focusedTermPosition.start);
                    const replaced = focusedEl.textContent + ' ';
                    const textAfter = text.substring(focusedTermPosition.end, text.length);
                    setTimeout(() => {
                        assert_1.assertNonNullish(inputEl, 'No reference to input.');
                        const position = textBefore.length + replaced.length;
                        inputEl.setSelectionRange(position, position);
                        inputEl.focus();
                    });
                    return textBefore + replaced + textAfter;
                });
            }
        }
    });
    /**
     * Function to handle onInput event.
     */
    const handleInput = event_callback_hook_1.useEventCallback((e) => {
        const target = e.target;
        if (target.tagName === 'INPUT') {
            setText(target.value);
        }
    });
    return {
        handleKeyDown,
        handleInput,
    };
}
exports.useKeyboardEvents = useKeyboardEvents;
//# sourceMappingURL=keyboard-events-hook.js.map